import { useI18n } from "../i18n/useI18n";
import type { Workload } from "../lib/types";

function workloadToPreview(w: Workload) {
  return {
    users_daily: w.usersDaily,
    requests_per_user: w.requestsPerUser,
    features: w.enabledFeatures,
    ai_request_share: w.aiRequestShare,
    avg_prompt_tokens: w.avgPromptTokens,
    avg_completion_tokens: w.avgCompletionTokens,
    storage_kb_per_user: w.storageKbPerUser,
  };
}

export function WorkloadJsonPreview({ workload }: { workload: Workload }) {
  const { t } = useI18n();
  return (
    <div className="json-preview">
      <span className="json-label">{t("form.jsonLabel")}</span>
      <pre>{JSON.stringify(workloadToPreview(workload), null, 2)}</pre>
      <style>{`
        .json-preview {
          margin-top: 1rem;
          border-top: 1px solid var(--border);
          padding-top: 1rem;
        }
        .json-label {
          font-size: 0.75rem;
          text-transform: uppercase;
          letter-spacing: 0.06em;
          color: var(--muted);
        }
        .json-preview pre {
          margin: 0.5rem 0 0;
          padding: 0.75rem;
          background: var(--bg);
          border-radius: 8px;
          border: 1px solid var(--border);
          font-size: 0.72rem;
          overflow: auto;
          max-height: 220px;
        }
      `}</style>
    </div>
  );
}
